const v1 = `/api/v1`;

const ApiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || `http://localhost:8080${v1}`,
  AUTH: `${v1}/auth`,
  CLIENTS: `/clients`,
  FAQS: `/faqs`,
  FAQ_INSERT: `/faq_insert`,
  FAQ_UPDATE: `/faq_update`,
  FAQ_UPDATE_ALT_QUE: `/faq_update_alt_que`,
  FAQ_INSERT_ALT_QUE: `/faq_insert_alt_que`,
  CHAT_HISTORY: `/chat_history`,
  LEAD_HISTORY: `/leads`,

  WEBSITES: `/websites`,
  LP_LIST: `/lps`,
  LP_SINGLE: `/lp_single`,
  LP_HANDLER: `/lp_handler`,
  LP_ADD_WIDGET: `/lp_add_widget`,
  LP_UPDATE_WIDGET: `/lp_update_widget`,
  LP_REMOVE_WIDGET: `/lp_remove_widget`,
  LP_SET_WIDGET_STATUS: `/lp_set_widget_status`,
  LP_UPDATE_WIDGET_ORDER: `/lp_update_widget_order`,
  LP_UPDATE_FIELDS: `/lp_update_fields`,
  GET_WS_INFO: `/get_ws_info`,
  WEBSITE_SINGLE: `/website_single`,
};

export { ApiConfig };
